/**
 * Determines whether the system is running as the CRM build or not. This will allow certain features to be toggled on or off depending on whether this setting is set.
 * @returns {boolean} The application is configured for CRM or not.
 */
// eslint-disable-next-line import/prefer-default-export
export const isBuildCRM = () => {
  const isCRM = process.env.VUE_APP_IS_CRM;
  if (isCRM === undefined || isCRM === 'false' || isCRM === false) {
    return false;
  }

  return true;
};
